import React, { Component } from "react";
import {
    MDBModalBody,
    MDBModalHeader,
    MDBSelect,
    MDBSelectInput,
    MDBSelectOptions,
    MDBSelectOption,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBModal,
    toast,
    MDBProgress,
    MDBBtn,
} from "mdbreact";
import AddSubscriber from "../../../../components/NetworkMgmt/Forms/AddSubscriber/AddSubscriber";
import ViewModifySubscribers from "../../../../components/NetworkMgmt/Venues/ViewVenueSubscribers";
import ResendActivation from "../../../../components/VenueMgmt/ResendActivation/ResendActivation";
import ServicesEndingSoon from "../../../../components/VenueMgmt/UpcomingExpirations/ServicesEndingSoon";
import axios from "../../../../axios";
import { withTranslation } from "react-i18next";
import DownloadSubscribers from "../../../../components/NetworkMgmt/Forms/BulkDownloadSubscribers/BulkDownloadSubscribers";
import UploadSubscribers from "../../../../components/NetworkMgmt/Forms/BulkUploadSubscribers/BulkUploadSubscribers";
import AbandonedSubscribers from "../../../../components/NetworkMgmt/Transactions/AbandonedSubscribers";
import InvoicesTable from "../../../../components/NetworkMgmt/Transactions/Invoices";
import PaymentUpdateRequiredTable from "../../../../components/NetworkMgmt/Transactions/PaymentUpdateRequired";
import SearchSubscribers from "../../../../components/NetworkMgmt/Subscribers/SearchSubscribers";
import AddGuest from "../../../../components/NetworkMgmt/Forms/AddGuest/AddGuest";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import _ from "lodash";
// import brandsData from "../../../../brands/common/brands.json";
let showSendEmail;
class SubscriberManagementNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalAddNewSubscriber: false,
            modalAddNewGuest: false,
            modalAddNewSubscriberResubmit: false,
            modalAddNewGuestResubmit: false,
            modalViewModifySubscriber: false,
            modalResendActivation: false,
            modalServicesEndingSoon: false,
            activeData: this.props.activeData,
            allActiveData: this.props.allActiveData,
            loading: false,
            loading_upload: false,
            loadingSearchResults: false,
            uploadSucceeded: undefined,
            lastProcessed: 0,
            unitForm: (
                <MDBSelect
                    id="selectUnit"
                    getValue={this.resetBuildingForm}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectUnit"
                        selected="Choose your unit"
                    />
                </MDBSelect>
            ),
            buildingForm: (
                <MDBSelect
                    id="selectBuilding"
                    getValue={this.handleSelectChangeBuilding}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectBuilding"
                        selected="Choose your building"
                    />
                </MDBSelect>
            ),
            floorForm: (
                <MDBSelect
                    id="selectFloor"
                    getValue={this.handleSelectChangeFloor}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectFloor"
                        selected="Choose your floor"
                    />
                </MDBSelect>
            ),
            editorHeaderState: EditorState.createEmpty(),
            editorMessageState: EditorState.createEmpty(),
            emailAddresses: [],
            value: "",
            error: null,
            paymentFailed: false,
            modalAddPayment: false,
            optionTemplateUnits: [],
            optionTemplateBuilding: [],
            optionTemplateFloor: [],
            optionTemplateServicePlans: [],
            modalModifyResident: false,
            modalEndedSubscriptionInfo: false,
            setSearchBy: "email",
            clearDropDown: true
        };
        this.findSubscribers = this.findSubscribers.bind(this);
    }
    componentDidMount() {
        this.getVenues();
    }
    componentDidUpdate() {
        // if(this.state.selectedUnit!==undefined && this.state.selectedBuilding!==undefined && this.state.selectedFloor !== undefined){
        //  this.setState({
        //   unitID_internal:
        //     this.state.unitData
        //      [this.state.selectedUnit]
        //      [this.state.selectedBuilding]
        //      [this.state.selectedFloor]["UnitID_internal"],
        //  })
        // }
    }
    // Prevent ESC key from closing parent modals when nested modals are open
    handleNestedModalKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
        }
    };
    toggleAddNewSubscriber = () => {
        this.setState({
            modalAddNewSubscriber: !this.state.modalAddNewSubscriber,
            clearDropDown: true,
            active: "false"
        });
    };
    toggleAddNewGuest = () => {
     this.setState({
         modalAddNewGuest: !this.state.modalAddNewGuest,
         clearDropDown: true,
         optionTemplateGuestUnits: [],
         selectedUnit: undefined,
         selectedBuilding: undefined,
         selectedFloor: undefined
     });
 };
    toggleViewModifySubscriber = () => {
        this.setState({
            modalViewModifySubscriber: !this.state.modalViewModifySubscriber,
            clearDropDown: true
        });
    };
    toggleResendActivation = () => {
        this.setState({
            modalResendActivation: !this.state.modalResendActivation,
        });
    };
    toggleServicesEndingSoon = () => {
        this.setState({
            modalServicesEndingSoon: !this.state.modalServicesEndingSoon,
        });
    };
    toggleBulkDownloadSubscribers = () => {
        this.setState({
            modalDownloadSubscribers: !this.state.modalDownloadSubscribers,
        });
    };
    toggleBulkUploadSubscribers = () => {
        this.setState({
            modalBulkUploadSubscribers: !this.state.modalBulkUploadSubscribers,
            clearDropDown: true
        });
    };
    toggleSearchSubscriber = () => {
        this.setState({
            modalSearchSubscriber: !this.state.modalSearchSubscriber,
            searchResults: undefined,
            subscriberEmail: "",
            subscriberPhone: "",
            venueID: undefined,
            selectedUnit: undefined,
            selectedBuilding: undefined,
            selectedFloor: undefined,
            unitID_internal: undefined,
            clearDropDown: true
        });
    };
    toggleAbandonedSubscribersTable = () => {
        this.setState({
            modalAbandonedSubscribersTable:
                !this.state.modalAbandonedSubscribersTable,
        });
    };
    toggleInvoicesTable = () => {
        this.setState({
            modalInvoicesTable: !this.state.modalInvoicesTable,
        });
    };
    togglePaymentUpdateRequiredTable = () => {
        this.setState({
            modalPaymentUpdateRequiredTable:
                !this.state.modalPaymentUpdateRequiredTable,
        });
    };
    toggleSendEmailSubscribers = () => {
        this.setState({
            modalSendEmailSubscribers: !this.state.modalSendEmailSubscribers,
        });
    };
    toggleError = () => {
        this.setState({
            modalError: !this.state.modalError,
        });
    };
    togglePayment = () => {
        this.setState({
            paymentFailed: false,
        });
        // Clear payment-related session storage when modal is closed
        sessionStorage.removeItem("unitID_internalSubscriber");
        sessionStorage.removeItem("stripeClientSecretSubscriber");
    };
    submitHandler = (
        venueID,
        dateEnd,
        email,
        firstName,
        lastName,
        phoneNumber,
        language,
        unitID,
        building,
        floor,
        contactpref_email,
        contactpref_sms,
        dateStart,
        unitID_internal,
        servicePlan,
        resubmitted
    ) => {
        let isoDateString;
        let isoDateStart;
        this.setState({
            loading: true,
            loadingRecreateSubscription: true,
        });
        if (!isNaN(new Date(dateEnd))) {
            isoDateString = new Date(dateEnd)
                .toISOString()
                .replace(/:00.\d+Z$/g, "Z");
        }
        if (!isNaN(new Date(dateStart))) {
            isoDateStart = new Date(dateStart)
                .toISOString()
                .replace(/:00.\d+Z$/g, "Z");
        }
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            GivenName: firstName,
            FamilyName: lastName,
            "PhoneNumber.E164": phoneNumber,
            locale: language,
            "EndDateTimeUTC.ISO8601": isoDateString,
            "StartDateTimeUTC.ISO8601": isoDateStart,
            VenueID: venueID,
            PolicyforSubscriberKey: {
                UnitID_internal: unitID_internal,
            },
            contactpref_email: true,
            contactpref_sms: contactpref_sms,
            UserTimeZone: new Date().getTimezoneOffset(),
            ServicePlanID: servicePlan,
        };
        
        // Generate NewKey for specific venue IDs
        if (venueID === "USA.MA.02030.DEV-GJ-01MANAGEDPROPERTIES.FRANKLIN._V3VENUE_.USA.MA.02771.TESTVENUE1.SEEKONK") {
            const generateNewKey = () => {
                const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const lowercase = "abcdefghijklmnopqrstuvwxyz";
                const numbers = "0123456789";
                const specialChars = "!@#$%^&*()_+-=[]{}|;:,<>?";
                const allChars = uppercase + lowercase + numbers + specialChars;
                
                let password = [
                    uppercase[Math.floor(Math.random() * uppercase.length)],
                    lowercase[Math.floor(Math.random() * lowercase.length)],
                    numbers[Math.floor(Math.random() * numbers.length)],
                    specialChars[Math.floor(Math.random() * specialChars.length)]
                ];
                
                for (let i = 0; i < 8; i++) {
                    password.push(allChars[Math.floor(Math.random() * allChars.length)]);
                }
                
                for (let i = password.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [password[i], password[j]] = [password[j], password[i]];
                }
                
                return password.join("");
            };
            
            body.NewKey = generateNewKey();
        }
        
        axios
            .post("/venuemgmtconsole/subscribers/addSubscriber", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(
                        response.data.message !== undefined
                            ? response.data.message
                            : "Added Subscriber!",
                        {
                            closeButton: false,
                        }
                    );
                    this.props.updateName(this.state.venueName, venueID);
                    this.findSubscribers();
                    this.setState({
                        loading: false,
                        loadingRecreateSubscription: false,
                    });
                    if (response.data.paymentFailed) {
                        this.setState({
                            paymentFailed: true,
                        });
                        resubmitted
                            ? this.toggleAddResidentResubmit()
                            : this.toggleAddNewSubscriber();
                    } else {
                        resubmitted
                            ? this.toggleAddResidentResubmit()
                            : this.toggleAddNewSubscriber();
                    }
                    sessionStorage.setItem(
                        "unitID_internalSubscriber",
                        response.data.Subscription.UnitID_internal
                    );
                    sessionStorage.setItem(
                        "stripeClientSecretSubscriber",
                        response.data.StripeClientSecret
                    );
                    sessionStorage.setItem("emailSubscriber", email);
                    sessionStorage.setItem("venueIDSubscriber", venueID);
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({
                        loading: false,
                        loadingRecreateSubscription: false,
                    });
                }
            );
    };
    submitHandlerGuest = (
     venueID,
     dateEnd,
     email,
     firstName,
     lastName,
     phoneNumber,
     language,
     unitID,
     building,
     floor,
     dateStart,
     unitID_internal,
     guest,
     resubmitted
    ) => {
     let isoDateString;
        let isoDateStart;
        this.setState({
            loading: true,
            loadingRecreateSubscription: true,
        });
        if (!isNaN(new Date(dateEnd))) {
            isoDateString = new Date(dateEnd)
                .toISOString()
                .replace(/:00.\d+Z$/g, "Z");
        }
        if (!isNaN(new Date(dateStart))) {
            isoDateStart = new Date(dateStart)
                .toISOString()
                .replace(/:00.\d+Z$/g, "Z");
        }
     let body = {
      AccessToken: sessionStorage.getItem("AccessToken"),
      IdToken: sessionStorage.getItem("IdToken"),
      EmailAddress: email,
      GivenName: firstName,
      FamilyName: lastName,
      "PhoneNumber.E164": phoneNumber,
      locale: language,
      "EndDateTimeUTC.ISO8601": isoDateString,
      "StartDateTimeUTC.ISO8601": isoDateStart,
      VenueID: venueID,
      PolicyforSubscriberKey: {
          UnitID_internal: unitID_internal,
      },
      UserTimeZone: new Date().getTimezoneOffset(),
      GuestKey: guest,
  };
  
  // Generate NewKey for specific venue IDs
  if (venueID === "USA.MA.02030.DEV-GJ-01MANAGEDPROPERTIES.FRANKLIN._V3VENUE_.USA.MA.02771.TESTVENUE1.SEEKONK") {
      const generateNewKey = () => {
          const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          const lowercase = "abcdefghijklmnopqrstuvwxyz";
          const numbers = "0123456789";
          const specialChars = "!@#$%^&*()_+-=[]{}|;:,<>?";
          const allChars = uppercase + lowercase + numbers + specialChars;
          
          let password = [
              uppercase[Math.floor(Math.random() * uppercase.length)],
              lowercase[Math.floor(Math.random() * lowercase.length)],
              numbers[Math.floor(Math.random() * numbers.length)],
              specialChars[Math.floor(Math.random() * specialChars.length)]
          ];
          
          for (let i = 0; i < 8; i++) {
              password.push(allChars[Math.floor(Math.random() * allChars.length)]);
          }
          
          for (let i = password.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [password[i], password[j]] = [password[j], password[i]];
          }
          
          return password.join("");
      };
      
      body.NewKey = generateNewKey();
  }
  
  axios
  .post("/venuemgmtconsole/subscribers/addSubscriber", body, {
      headers: {},
  })
  .then(
      (response) => {
          toast.success(
              response.data.message !== undefined
                  ? response.data.message
                  : "Added Guest!",
              {
                  closeButton: false,
              }
          );
           this.findSubscribers();
           this.setState({
                        loading: false,
                        loadingRecreateSubscription: false,
                    });
          this.props.updateName(this.state.venueName, venueID);
          resubmitted
                            ? this.toggleAddGuestResubmit()
                            : this.toggleAddNewGuest();
          // this.toggleAddNewGuest();
          sessionStorage.setItem(
              "unitID_internalSubscriber",
              response.data.Subscription.UnitID_internal
          );
          sessionStorage.setItem(
              "stripeClientSecretSubscriber",
              response.data.StripeClientSecret
          );
            sessionStorage.setItem("emailSubscriber", email);
            sessionStorage.setItem("venueIDSubscriber", venueID);
      },
      (error) => {
          toast.error(error.response.data.message, {
              closeButton: false,
          });
          this.setState({
              loading: false,
              loadingRecreateSubscription: false,
          });
      }
  );
    }
    submitHandlerResendActivation = (email) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: this.props.venueID,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({ loading: true });
        axios
            .post("/venuemgmtconsole/subscribers/resendCodeforTandC", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Resent Confirmation!", {
                        closeButton: false,
                    });
                    this.toggleResendActivation();
                    this.setState({ loading: false });
                },
                (error) => {
                    toast.error("There was an error", {
                        closeButton: false,
                    });
                    this.toggleResendActivation();
                    this.setState({ loading: false });
                }
            );
    };
    getVenues = (selectedID) => {
        this.setState({
            // venueID: undefined,
            // selectedUnit: undefined,
            // selectedBuilding: undefined,
            // selectedFloor: undefined,
            // optionTemplateBuilding: [],
            // optionTemplateFloor: [],
            // optionTemplateUnits: [],
            // unitID_internal: undefined,
            // venueName: undefined,
        });
        this.setState({ attributeForm: [] });
        let body = { 
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post("/networkoperatorconsole/venues/listVenues", body, {
                headers: {},
            })
            .then((response) => {
                var formArrayVenues = [];
                let optionTemplateVenues = [];
                this.setState({ venueList: response.data.VenueList });
                Object.keys(response.data.VenueList).map((oneKey, i) => {
                    if (selectedID === undefined) {
                        this.setState({ firstID: oneKey });
                    }
                    if (selectedID === oneKey) {
                        optionTemplateVenues.push(
                            <MDBSelectOption selected value={oneKey}>
                                {response.data.VenueList[oneKey]["VenueName"]}
                            </MDBSelectOption>
                        );
                    } else {
                        optionTemplateVenues.push(
                            <MDBSelectOption value={oneKey}>
                                {response.data.VenueList[oneKey]["VenueName"]}
                            </MDBSelectOption>
                        );
                    }
                    return true;
                });
                formArrayVenues.push(
                    <MDBSelect
                        id="selectVenueSubscriberModal"
                        getValue={this.handleSelectChangeVenue}
                        className="form-control"
                    >
                        <MDBSelectInput
                            className="selectInput venueSelectedSubscriberModal"
                            selected="Choose your venue"
                        />
                        <MDBSelectOptions search>
                            {optionTemplateVenues}
                        </MDBSelectOptions>
                    </MDBSelect>
                );
                this.setState({
                    attributeForm: formArrayVenues,
                });
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    };
    getVenueDetails = async (venueID) => {
        // console.log("ResidentNavigation - getVenueDetails: ", venueID)
        this.setState({
            loadingVenueDetails: true,
        });
        let unitData = {};
        let guestUnitData = {};
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID:
                venueID === undefined
                    ? sessionStorage.getItem("venueID")
                    : venueID,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({
            address1: undefined,
            address2: undefined,
            city: undefined,
            region: undefined,
            country: undefined,
            postalcode: undefined,
            unitData: undefined,
            expiringData: undefined,
            searchData: undefined,
            value: "",
            defaultSubscriptionDurationRes: 0,
            loading: true,
            unifForm: undefined,
            hasUpdated: false,
            optionTemplateUnits: [],
            isVenuePMSConfigured: false
        });
        await axios
            .post("/networkoperatorconsole/venues/listVenueDetails", body, {
                headers: {},
            })
            .then((response) => {
             unitData = response.data[venueID]["Units-Building-Floor-List-Subscribers"];
             guestUnitData  = response.data[venueID]["Units-Building-Floor-List-GuestNetworks"];
             const mergedObj = Object.assign({}, unitData, guestUnitData);
                this.setState({
                    address1: response.data[venueID]["AddressLine1"],
                    address2: response.data[venueID]["AddressLine2"],
                    city: response.data[venueID]["City"],
                    region: response.data[venueID]["State"],
                    country: response.data[venueID]["Country.ISO3166A3"],
                    postalcode: response.data[venueID]["PostalCode"],
                    unitData:
                    mergedObj,
                    // defaultSubscriptionDurationRes:
                    //     response.data[venueID][
                    //         "DefaultSubscriptionDurationHours_GlobalWirelessPlusLocalWiredAccess"
                    //     ],
                    venueServicePlans:
                        response.data[venueID]["AvailableServicePlans"],
                    hasUpdated: true,
                    venueInfo: response.data[venueID],
                    timezone: response.data[venueID]["TimeZoneOffset"], //+4
                    duration:
                        response.data[venueID][
                            "DefaultSubscriptionDurationHours_LocalWirelessAccess"
                        ],
                    isVenuePMSConfigured: !!(response.data[venueID].PMS && response.data[venueID].PMS.ProfileID)
                });
                // let optionTemplatePlans = [];
                // Object.keys(response.data[venueID]["AvailableServicePlans"]).map(
                //   (oneKey, i) => {
                //     optionTemplatePlans.push({
                //       value: oneKey,
                //       name: response.data[venueID]["AvailableServicePlans"][oneKey][
                //         "ServicePlanName"
                //       ],
                //     });
                //     return true;
                //   }
                // );
                // this.setState({
                //   optionTemplatePlans: optionTemplatePlans,
                //   loading_prop_groups: false,
                // });
                // this.setState({ loadingVenueDetails: false });
                let units = Object.keys(
                    response.data[venueID][
                        "Units-Building-Floor-List-Subscribers"
                    ]
                );
                let buildings = [];
                let objUnits = {};
                let objUnitsSearch = {};
                for (let i = 0; i < units.length; i++) {
                    buildings.push(
                        Object.keys(
                            response.data[venueID][
                                "Units-Building-Floor-List-Subscribers"
                            ][units[i]]
                        )
                    );
                    for (let j = 0; j < buildings[i].length; j++) {
                        let floor = Object.keys(
                            response.data[venueID][
                                "Units-Building-Floor-List-Subscribers"
                            ][units[i]][buildings[i][j]]
                        );
                        for (let k = 0; k < floor.length; k++) {
                            const unitData = response.data[venueID][
                                "Units-Building-Floor-List-Subscribers"
                            ][units[i]][buildings[i][j]][floor[k]];
                            const subscriptions = unitData["Subscriptions"];
                            const subscriptionKeys = Object.keys(subscriptions);
                            const hasActiveSubscription = subscriptionKeys.length > 0;
                            let subscriptionExpired = false;
                            if (hasActiveSubscription) {
                                // Check if the subscription end date is before today
                                const endDate = new Date(subscriptions[subscriptionKeys[0]]["EndDateTimeUTC.ISO8601"]);
                                const today = new Date();
                                subscriptionExpired = endDate < today;
                            }
                            if (
                                unitData["PrimaryUnitID_internal"] === "" &&
                                ((unitData["allowOverlappingSubscriptionWiredUnit"] === false &&
                                    (!hasActiveSubscription || subscriptionExpired)) ||
                                    unitData["allowOverlappingSubscriptionWiredUnit"] === true)
                            ) {
                                objUnits[i] =
                                    response.data[venueID][
                                        "Units-Building-Floor-List-Subscribers"
                                    ][units[i]][buildings[i]];
                            }
                         // Show all units in the search dropdown regardless of
                         // whether they currently have a subscription (NETWORKUI-539 reverted)
                         objUnitsSearch[i] =
                             response.data[venueID][
                                 "Units-Building-Floor-List-Subscribers"
                             ][units[i]][buildings[i]];
                     }
                    }
                }
                let optionTemplateUnits = [];
                let optionTemplateUnitsSearch = [];
                Object.keys(objUnitsSearch).map((oneKey, i) => {
                    optionTemplateUnitsSearch.push({
                        value: units[oneKey],
                        name: units[oneKey],
                    });
                    return true;
                });
                Object.keys(objUnits).map((oneKey, i) => {
                    optionTemplateUnits.push({
                        value: units[oneKey],
                        name: units[oneKey],
                    });
                    return true;
                });
                let guestUnits = Object.keys(
                 response.data[venueID][
                     "Units-Building-Floor-List-GuestNetworks"
                 ]
             );
             let guestBuildings = [];
             let objGuestUnits = {};
             for (let i = 0; i < guestUnits.length; i++) {
              guestBuildings.push(
                     Object.keys(
                         response.data[venueID][
                             "Units-Building-Floor-List-GuestNetworks"
                         ][guestUnits[i]]
                     )
                 );
                 for (let j = 0; j < guestBuildings[i].length; j++) {
                     let guestFloor = Object.keys(
                         response.data[venueID][
                             "Units-Building-Floor-List-GuestNetworks"
                         ][guestUnits[i]][guestBuildings[i][j]]
                     );
                     for (let k = 0; k < guestFloor.length; k++) {
                      objGuestUnits[i] =
                             response.data[venueID][
                                 "Units-Building-Floor-List-GuestNetworks"
                             ][guestUnits[i]][guestBuildings[i]];
                     }
                 }
             }
             let optionTemplateGuestUnits = [];
             Object.keys(objGuestUnits).map((oneKey, i) => {
              optionTemplateGuestUnits.push({
                     value: guestUnits[oneKey],
                     name: guestUnits[oneKey],
                 });
                 return true;
             });
                let optionTemplateServicePlans = [];
                Object.keys(
                    response.data[venueID]["AvailableServicePlans"]
                 ).map((value, i) => {
                        optionTemplateServicePlans.push({
                            value: response.data[venueID]["AvailableServicePlans"][
                                value
                            ]["ServicePlanID"],
                            name: response.data[venueID]["AvailableServicePlans"][
                                value
                            ]["ServicePlanName"],
                        });
                        return null;
                    });
                this.setState({
                    optionTemplateUnits: optionTemplateUnits,
                    optionTemplateUnitsSearch: optionTemplateUnitsSearch,
                    optionTemplateGuestUnits: optionTemplateGuestUnits,
                    optionTemplateServicePlans: optionTemplateServicePlans,
                    loading: false,
                    clearDropDown: false,
                    loadingVenueDetails: false,
                });
                var offset =
                    (new Date().getTimezoneOffset() +
                        response.data[venueID]["TimeZoneOffset"] * 60) *
                    60 *
                    1000;
                let offsetTimestamp = new Date().getTime() + offset;
                let offsetDateStart = new Date(offsetTimestamp);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                let offsetTimestampNow = new Date().getTime() + offset;
                let offsetDateStartNow = new Date(offsetTimestampNow);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                this.setState({
                    dateStartNow: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStartNow),
                });
            })
            .catch((error) => {
                this.setState({ loadingVenueDetails: false });
                this.setState({
                    error: true,
                    loading: false,
                });
            });
    };
    findSubscribers = async () => {
        // event.preventDefault();
        console.log(this.state.setSearchBy);
        this.setState({
            loadingSearchResults: true,
            searchResults: undefined,
        });
        let body;
        switch (this.state.setSearchBy) {
            case "email": {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    EmailAddress: this.state.subscriberEmail?.trim(),
                };
                break;
            }
            case "phone": {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    "PhoneNumber.E164": this.state.subscriberPhone,
                };
                break;
            }
            case "venue": {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    IdToken: sessionStorage.getItem("IdToken"),
                    VenueID: this.props.venueID,
                    UnitID_internal: this.state.unitID_internal,
                };
                const venueID = sessionStorage.getItem("venueID");
                if (venueID !== null && venueID !== "undefined") {
                    body.VenueID = venueID;
                }
                break;
            }
            default: {
                body = {
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    EmailAddress: this.state.subscriberEmail.trim(),
                };
                break;
            }
        }
        await axios
            .post(
                "/networkoperatorconsole/shoppingcart/listSubscriptions",
                body,
                {
                    headers: {},
                }
            )
            .then(
                (response) => {
                    this.setState({
                        searchResults: response.data.Subscriptions,
                        loadingSearchResults: false,
                    });
                    // this.updateClassName(response.data.Subscriptions);
                },
                (error) => {
                    this.setState({ loadingSearchResults: false });
                }
            );
    };
    getVenueUnitDetails = (key, venueID, index, active, subToken) => {
        this.setState({ loadingVenueDetails: true });
        if (index === undefined) {
            index = this.props.firstID;
        }
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            UnitID_internal:
                index === undefined
                    ? sessionStorage.getItem("unitID_internalSubscriber")
                    : index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        // eslint-disable-next-line no-unused-vars
        let subscriptionID;
        let unitType;
        this.setState({
            unitSubscriptionsList: undefined,
            SubscriberGivenName: undefined,
            SubscriberFamilyName: undefined,
            SubscriberEmail: undefined,
            SubscriberPhoneNumber: undefined,
            contactpref_email: undefined,
            contactpref_sms: undefined,
            SubscriberLocale: undefined,
            UnitFloor: undefined,
            UnitBuilding: undefined,
            SSID: undefined,
            StartDateTime: undefined,
            EndDateTime: undefined,
            UnitID: undefined,
            unitID_internal: undefined,
            servicePlanID: undefined,
            servicePlan: undefined,
            vlan: undefined,
            status: undefined,
            PMS: undefined,
            PMSSyncDate: undefined,
            subscriberManagedviaSSO: undefined,
            paymentFailed: undefined,
            StripeClientSecret: undefined,
            country: undefined,
            subscriptionDiscount: undefined,
            venueDiscount: undefined,
            externalSubscriberID: undefined,
            availablePlans: undefined,
            selectedServicePlanPrice: undefined,
            setupIntentID: undefined,
            active: active,
            venueUnitData: undefined,
        });
        axios
            .post("/networkoperatorconsole/venues/listVenueUnitDetails", body, {
                headers: {},
            })
            .then((response) => {
                // console.log("ResidentNav - this.state.searchResults: ", this.state.searchResults)
                subscriptionID = Object.keys(
                    response.data["VenueUnits"][0]["Subscriptions"]
                );
                unitType = response.data["VenueUnits"][0]["purpose"];
                sessionStorage.setItem(
                    "venueID",
                    this.state.searchResults[key]["VenueID"]
                );
                // console.log(response.data["VenueUnits"][0]["Subscriptions"])
                let subscriptions = response.data["VenueUnits"][0]["Subscriptions"];
                let guestSubscriptions = response.data["VenueUnits"][0]["GuestSubscriptions"]
                _.merge(subscriptions, guestSubscriptions);
                let subscriptionKey;
                Object.keys(
                 subscriptions
             // eslint-disable-next-line array-callback-return
             ).map((value, i) => {
                if(value.includes(subToken)){
                 subscriptionKey = value
                }
             });
                this.setState({
                    unitSubscriptionsList: response.data["VenueUnits"][0],
                    subscriptionID: Object.keys(
                     subscriptions
                    ),
                    venueID: response.data["VenueUnits"][0]["Venue"]["VenueID"],
                    venueUnitData: response.data["VenueUnits"],
                });
                this.setState({ loadingVenueDetails: false });
                if (active === "Active") {
                 if(unitType === "localwirelessonly") {
                  this.setState({
                   venueName: this.state.searchResults[key].VenueName,
                   SubscriberGivenName:
                       this.state.searchResults[key].GivenName,
                   SubscriberFamilyName:
                       this.state.searchResults[key].FamilyName,
                   SubscriberEmail:
                       this.state.searchResults[key].EmailAddress,
                   SubscriberPhoneNumber:
                       this.state.searchResults[key]["PhoneNumber.E164"],
                   contactpref_email:
                       this.state.searchResults[key].contactpref_email,
                   contactpref_sms:
                       this.state.searchResults[key].contactpref_sms,
                   SubscriberLocale: this.state.searchResults[key].locale,
                   UnitFloor:
                       this.state.unitSubscriptionsList["UnitFloor"],
                   UnitBuilding:
                       this.state.unitSubscriptionsList["UnitBuilding"],
                   SSID: this.state.searchResults[key].ssid,
                   StartDateTime:
                       this.state.unitSubscriptionsList["GuestSubscriptions"][
                        subscriptionKey
                       ]["StartDateTimeUTC.ISO8601"],
                   EndDateTime:
                       this.state.unitSubscriptionsList["GuestSubscriptions"][
                        subscriptionKey
                       ]["EndDateTimeUTC.ISO8601"],
                   UnitID: this.state.unitSubscriptionsList["UnitID"],
                   unitID_internal:
                       this.state.unitSubscriptionsList["UnitID_internal"],
                   // servicePlanID:
                   //     this.state.unitSubscriptionsList["Subscriptions"][
                   //         this.state.subscriptionID
                   //     ]["ServicePlan"]["ServicePlanID"],
                   // servicePlan:
                   //     this.state.unitSubscriptionsList["Subscriptions"][
                   //         this.state.subscriptionID
                   //     ]["ServicePlan"]["ServicePlanName"],
                   // vlan: this.state.unitSubscriptionsList["vlan"],
                   // status: this.state.searchResults[key]
                   //     .AccountStatusAtCreation,
                   // subscriberManagedviaSSO:
                   //     this.state.searchResults[key][
                   //         "SubscriberManagedviaSSO"
                   //     ],
                   // paymentFailed:
                   //     this.state.searchResults[key]["paymentFailed"],
                   // StripeClientSecret:
                   //     this.state.searchResults[key]["StripeClientSecret"],
                   // country:
                   //     this.state.searchResults[key]["Country.ISO3166A3"],
                   // subscriptionDiscount:
                   //     this.state.searchResults[key][
                   //         "VenueUnitPriceAdjustment"
                   //     ],
                   // venueDiscount:
                   //     this.state.searchResults[key][
                   //         "VenuePriceAdjustment"
                   //     ],
                   // externalSubscriberID:
                   //     this.state.searchResults[key][
                   //         "externalSubscriberID"
                   //     ],
                   // availablePlans:
                   //     this.state.unitSubscriptionsList[
                   //         "AvailableServicePlans"
                   //     ],
                   // selectedServicePlanPrice:
                   //     this.state.searchResults[key][
                   //         "ListBillingCyclePrice.USD"
                   //     ],
                   // stripeClientParentSecret:
                   //     this.state.searchResults[key]["StripeClientSecret"],
                   // setupIntentID:
                   //     this.state.searchResults[key]["SetupIntentId"],
                   active: "true",
               });
               console.log(subscriptionKey);
               this.toggleModifyGuest(active) 
                 }else{
                    this.setState({
                        venueName: this.state.searchResults[key].VenueName,
                        SubscriberGivenName:
                            this.state.searchResults[key].GivenName,
                        SubscriberFamilyName:
                            this.state.searchResults[key].FamilyName,
                        SubscriberEmail:
                            this.state.searchResults[key].EmailAddress,
                        SubscriberPhoneNumber:
                            this.state.searchResults[key]["PhoneNumber.E164"],
                        contactpref_email:
                            this.state.searchResults[key].contactpref_email,
                        contactpref_sms:
                            this.state.searchResults[key].contactpref_sms,
                        SubscriberLocale: this.state.searchResults[key].locale,
                        UnitFloor:
                            this.state.unitSubscriptionsList["UnitFloor"],
                        UnitBuilding:
                            this.state.unitSubscriptionsList["UnitBuilding"],
                        SSID: this.state.searchResults[key].ssid,
                        StartDateTime:
                            this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["StartDateTimeUTC.ISO8601"],
                        EndDateTime:
                            this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["EndDateTimeUTC.ISO8601"],
                        UnitID: this.state.unitSubscriptionsList["UnitID"],
                        unitID_internal:
                            this.state.unitSubscriptionsList["UnitID_internal"],
                        servicePlanID:
                            this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["ServicePlan"]["ServicePlanID"],
                        servicePlan:
                            this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["ServicePlan"]["ServicePlanName"],
                        vlan: this.state.unitSubscriptionsList["vlan"],
                        status: this.state.searchResults[key]
                            .AccountStatusAtCreation,
                        PMS: this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["PMS"],
                        PMSSyncDate:
                            this.state.unitSubscriptionsList["Subscriptions"][
                             subscriptionKey
                            ]["PMS"]["SyncDateTimeUTC"],
                        subscriberManagedviaSSO:
                            this.state.searchResults[key][
                                "SubscriberManagedviaSSO"
                            ],
                        paymentFailed:
                            this.state.searchResults[key]["paymentFailed"],
                        StripeClientSecret:
                            this.state.searchResults[key]["StripeClientSecret"],
                        country:
                            this.state.searchResults[key]["Country.ISO3166A3"],
                        subscriptionDiscount:
                            this.state.searchResults[key][
                                "VenueUnitPriceAdjustment"
                            ] / 100,
                        venueDiscount:
                            this.state.searchResults[key][
                                "VenuePriceAdjustment"
                            ] / 100,
                        externalSubscriberID:
                            this.state.searchResults[key][
                                "externalSubscriberID"
                            ],
                        availablePlans:
                            this.state.unitSubscriptionsList[
                                "AvailableServicePlans"
                            ],
                        selectedServicePlanPrice:
                            this.state.searchResults[key][
                                "ListBillingCyclePrice.USD"
                            ],
                        stripeClientParentSecret:
                            this.state.searchResults[key]["StripeClientSecret"],
                        setupIntentID:
                            this.state.searchResults[key]["SetupIntentId"],
                        active: "true",
                    });
                    console.log(unitType);
                    this.toggleModifyResident(active);
                   }
                } else {
                    this.setState({
                        venueName: this.state.searchResults[key].VenueName,
                        SubscriberGivenName:
                            this.state.searchResults[key].GivenName,
                        SubscriberFamilyName:
                            this.state.searchResults[key].FamilyName,
                        SubscriberEmail:
                            this.state.searchResults[key].EmailAddress,
                        SubscriberPhoneNumber:
                            this.state.searchResults[key]["PhoneNumber.E164"],
                        contactpref_email:
                            this.state.searchResults[key].contactpref_email,
                        contactpref_sms:
                            this.state.searchResults[key].contactpref_sms,
                        SubscriberLocale: this.state.searchResults[key].locale,
                        StartDateTime:
                            this.state.searchResults[key][
                                "StartDateTimeUTC.ISO8601"
                            ],
                        EndDateTime:
                            this.state.searchResults[key][
                                "EndDateTimeUTC.ISO8601"
                            ],
                        unitID_internal:
                            this.state.searchResults[key]["UnitID_internal"],
                        servicePlanID:
                            this.state.searchResults[key]["ServicePlanID"],
                        servicePlan:
                            this.state.searchResults[key]["ServicePlanName"],
                        // vlan: this.state.unitSubscriptionsList["vlan"],
                        // status: this.state.searchResults[key].AccountStatusAtCreation,
                        PMS: this.state.searchResults[key]["PMS"],
                        PMSSyncDate:
                            this.state.searchResults[key]["PMS"]["SyncDateTimeUTC"],
                        // subscriberManagedviaSSO:
                        //   this.state.searchResults[key]["SubscriberManagedviaSSO"],
                        // paymentFailed: this.state.searchResults[key]["paymentFailed"],
                        StripeClientSecret:
                            this.state.searchResults[key]["StripeClientSecret"],
                        country:
                            this.state.searchResults[key]["Country.ISO3166A3"],
                        subscriptionDiscount:
                            this.state.searchResults[key][
                                "VenueUnitPriceAdjustment"
                            ] / 100,
                        venueDiscount:
                            this.state.searchResults[key][
                                "VenuePriceAdjustment"
                            ] / 100,
                        externalSubscriberID:
                            this.state.searchResults[key][
                                "externalSubscriberID"
                            ],
                        availablePlans:
                            this.state.unitSubscriptionsList[
                                "AvailableServicePlans"
                            ],
                        selectedServicePlanPrice:
                            this.state.searchResults[key][
                                "ListBillingCyclePrice.USD"
                            ],
                        stripeClientParentSecret:
                            this.state.searchResults[key]["StripeClientSecret"],
                        setupIntentID:
                            this.state.searchResults[key]["SetupIntentId"],
                        active: "false",
                    });
                    this.toggleEndedSubscriptionInfo(active);
                }
                this.getVenueDetails(venueID);
            })
            .catch((error) => {
                this.setState({ error: true });
                // console.log(error)
                if(error.response.data.message!==undefined){
                 toast.error(error.response.data.message, {
                  closeButton: false,
              });
                }
                this.setState({ loadingVenueDetails: false });
            });
    };
    handleSelectChangeVenue = (value, name) => {
        // console.log("handleSelectChangeValue: ", value)
        this.setState({
            optionTemplateUnits: [],
            optionTemplateGuestUnits: [],
            optionTemplateBuilding: [],
            optionTemplateFloor: [],
            unitID_internal: undefined,
            selectedUnit: undefined,
        });
        var venue = name;
        var lDiv = document.createElement("div");
        document.body.appendChild(lDiv);
        lDiv.style.fontSize = "" + 20 + "px";
        lDiv.style.position = "absolute";
        lDiv.style.left = -1000;
        lDiv.style.top = -1000;
        lDiv.innerHTML = venue;
        document.body.removeChild(lDiv);
        lDiv = null;
        sessionStorage.setItem("venueName", venue);
        sessionStorage.setItem("venueID", value);
        // console.log("Updated Venue: ", value)
        this.getVenueDetails(value);
        this.setState({ selectedID: value });
        this.updateName(venue, value);
    };
    handleSelectChangeVenueFromList = (venueName, venueID) => {
        sessionStorage.setItem("venueName", venueName);
        sessionStorage.setItem("venueID", venueID);
        this.getVenues(venueID);
        this.setState({ selectedID: venueID });
        this.updateName(venueName, venueID);
    };
    resetBuildingForm = (value) => {
        this.setState({
            buildingForm: (
                <MDBSelect
                    id="selectBuilding"
                    getValue={this.handleSelectChangeBuilding}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectBuilding"
                        selected="Choose your building"
                    />
                </MDBSelect>
            ),
        });
        this.setState({
            floorForm: (
                <MDBSelect
                    id="selectFloor"
                    getValue={this.handleSelectChangeFloor}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectFloor"
                        selected="Choose your floor"
                    />
                </MDBSelect>
            ),
        });
        setTimeout(() => {
            this.handleSelectChangeUnit(value);
        }, 1);
    };
    handleSelectChangeUnit = async (value) => {
        await this.setState({
            selectedUnit: value,
        });
        console.log(this.state.unitData[value])
        if (this.state.unitData !== undefined && this.state.unitData[value] !== undefined) {
            this.setState({
                // selectedUnit: value,
                optionTemplateBuilding: [],
                // optionTemplateFloor: [],
                selectedBuilding: undefined,
                selectedFloor: undefined,
            });
            let optionTemplateBuilding = [];
            this.setState({
                optionTemplateBuilding: [],
            });
            Object.keys(this.state.unitData[value]).map((oneKey, i) => {
                if (oneKey === "DEFAULT") {
                    optionTemplateBuilding.push({
                        value: oneKey,
                        name: oneKey,
                    });
                } else {
                    optionTemplateBuilding.push({
                        value: oneKey,
                        name: oneKey,
                    });
                }
                return true;
            });
            this.setState({
                optionTemplateBuilding: optionTemplateBuilding,
            }, () => {
                // Auto-select building if there's only one option
                if (optionTemplateBuilding.length === 1) {
                    setTimeout(() => {
                        this.handleSelectChangeBuilding(optionTemplateBuilding[0].value);
                    }, 50);
                }
            });
        }
    };
    handleSelectChangeUnitInitial = async (value) => {
        console.log("Value: ", value);
        await this.setState({
            selectedUnit: value,
        });
        console.log(this.state.unitData[value])
        if (this.state.unitData !== undefined && this.state.unitData[value] !== undefined) {
            this.setState({
                // selectedUnit: value,
                optionTemplateBuilding: [],
                // optionTemplateFloor: [],
                // selectedBuilding: undefined,
                // selectedFloor: undefined,
            });
            let optionTemplateBuilding = [];
            this.setState({
                optionTemplateBuilding: [],
            });
            Object.keys(this.state.unitData[value]).map((oneKey, i) => {
                if (oneKey === "DEFAULT") {
                    optionTemplateBuilding.push({
                        value: oneKey,
                        name: oneKey,
                    });
                } else {
                    optionTemplateBuilding.push({
                        value: oneKey,
                        name: oneKey,
                    });
                }
                return true;
            });
            this.setState({
                optionTemplateBuilding: optionTemplateBuilding,
            });
        }
    };
    resetFloorForm = (value) => {
        setTimeout(() => {
            this.handleSelectChangeBuilding(value);
        }, 1);
    };
    handleSelectChangeBuilding = (selectedBuilding) => {
        if (
            selectedBuilding !== null &&
            this.state.selectedUnit !== undefined &&
            this.state.unitData !== undefined &&
            this.state.unitData[this.state.selectedUnit] !== undefined
        ) {
            // console.log("ResidentNavigation - handleSelectChangeBuilding - selectedBuilding: ", selectedBuilding)
            // console.log("ResidentNavigation - handleSelectChangeBuilding - selectedUnit: ", selectedUnit)
            this.setState({
                selectedBuilding: selectedBuilding,
                selectedFloor: undefined,
                unitID_internal: undefined,
                // selectedUnit: selectedUnit
            });
            let optionTemplateFloor = [];
            Object.keys(
                this.state.unitData[this.state.selectedUnit][selectedBuilding]
            ).map((oneKey, i) => {
                if (oneKey === "DEFAULT") {
                    optionTemplateFloor.push({ value: oneKey, name: oneKey });
                } else {
                    optionTemplateFloor.push({ value: oneKey, name: oneKey });
                }
                return true;
            });
            // console.log("handleSelectChangeBuilding: optionTemplateFloor: ", optionTemplateFloor)
            this.setState({
                optionTemplateFloor: optionTemplateFloor,
            }, () => {
                // Auto-select floor if there's only one option
                if (optionTemplateFloor.length === 1) {
                    setTimeout(() => {
                        this.handleSelectChangeFloor(optionTemplateFloor[0].value, this.state.selectedUnit, selectedBuilding);
                    }, 50);
                }
            });
        }
    };
    // handleSelectChangeFloor = async(selectedFloor, selectedUnit, selectedBuilding) => {
    //  console.log("ResidentNavigation - handleSelectChangeFloor - selectedUnit: ", selectedUnit)
    //  console.log("ResidentNavigation - handleSelectChangeFloor - selectedFloor: ", selectedFloor)
    //  console.log("ResidentNavigation - handleSelectChangeFloor - selectedBuilding: ", selectedBuilding)
    //  await this.setState({
    //   unitID_internal:
    //     this.state.unitData
    //      [this.state.selectedUnit === undefined ? selectedUnit : this.state.selectedUnit]
    //      [this.state.selectedBuilding === undefined ? selectedBuilding : this.state.selectedBuilding]
    //      [selectedFloor]["UnitID_internal"],
    //   unitID_internal1:
    //   this.state.unitData
    //   [this.state.selectedUnit === undefined ? selectedUnit : this.state.selectedUnit]
    //   [this.state.selectedBuilding === undefined ? selectedBuilding : this.state.selectedBuilding]
    //   [selectedFloor]["UnitID_internal"],
    // });
    //   if (selectedFloor !== null) {
    //     this.setState({ selectedFloor: selectedFloor });
    //     // console.log("Resident Mgmt/this.state.unitData: ", this.state.unitID_internal1)
    //     // console.log("Resident Mgmt/HandleSelectChangeFloor: ", this.state.unitData
    //     //  [this.state.selectedUnit === undefined ? selectedUnit : this.state.selectedUnit]
    //     //  [this.state.selectedBuilding === undefined ? selectedBuilding : this.state.selectedBuilding]
    //     //  [selectedFloor]["UnitID_internal"])
    //     // console.log("Resident Mgmt/SelectedFloor/Unit/Building: ", selectedFloor, selectedUnit, selectedBuilding)
    //   }
    // };
    handleSelectChangeFloor = (value) => {
        if (
            value !== null &&
            this.state.unitData !== undefined &&
            this.state.selectedUnit !== undefined &&
            this.state.selectedBuilding !== undefined &&
            this.state.unitData[this.state.selectedUnit] !== undefined &&
            this.state.unitData[this.state.selectedUnit][this.state.selectedBuilding] !== undefined
        ) {
            this.setState({ selectedFloor: value });
            this.setState({
                unitID_internal:
                    this.state.unitData[this.state.selectedUnit][
                        this.state.selectedBuilding
                    ][value]["UnitID_internal"],
            });
        }
    };
    updateName = (value, index) => {
        sessionStorage.setItem("venueName", value);
        sessionStorage.setItem("venueID", index);
        this.setState({
            venueID: index,
            venueName: value,
        });
    };
    onEditorHeaderStateChange = (editorHeaderState) => {
        this.setState({
            editorHeaderState,
            editorHeaderContent: draftToHtml(
                convertToRaw(editorHeaderState.getCurrentContent())
            ),
        });
    };
    onEditorMessageStateChange = (editorMessageState) => {
        this.setState({
            editorMessageState,
            editorMessageContent: draftToHtml(
                convertToRaw(editorMessageState.getCurrentContent())
            ),
        });
    };
    handleKeyDown = (evt) => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            var value = this.state.value.trim();
            if (value && this.isValid(value)) {
                this.setState({
                    emailAddresses: [
                        ...this.state.emailAddresses,
                        this.state.value,
                    ],
                    value: "",
                });
            }
        }
    };
    handleChange = (evt) => {
        this.setState({
            value: evt.target.value,
            error: null,
        });
    };
    handleDelete = (item) => {
        this.setState({
            emailAddresses: this.state.emailAddresses.filter((i) => i !== item),
        });
    };
    handlePaste = (evt) => {
        evt.preventDefault();
        var paste = evt.clipboardData.getData("text");
        var emails = paste.match(/[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/g);
        if (emails) {
            var toBeAdded = emails.filter((email) => !this.isInList(email));
            this.setState({
                emailAddresses: [...this.state.emailAddresses, ...toBeAdded],
            });
        }
    };
    isValid(email) {
        let error = null;
        if (this.isInList(email)) {
            error = `${email} has already been added.`;
        }
        if (!this.isEmail(email)) {
            error = `${email} is not a valid email address.`;
        }
        if (error) {
            this.setState({ error });
            return false;
        }
        return true;
    }
    isInList(email) {
        return this.state.emailAddresses.includes(email);
    }
    isEmail(email) {
        return /[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/.test(email);
    }
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerPhone = (event) => {
        this.setState({ subscriberPhone: event });
    };
    submitSendEmail = (event) => {
        event.preventDefault();
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddresses: this.state.emailAddresses,
            Subject: this.state.emailSubject,
            title: this.state.emailTitle,
            header: this.state.editorHeaderContent,
            message: this.state.editorMessageContent,
            EmailFromARN:
                "arn:aws:ses:us-east-1:450961373892:identity/vault-admin@roamingiq.com",
            actionbutton: " ",
        };
        this.setState({ sendEmail: true });
        axios
            .post("/operatorconsole/subscribers/sendEmail", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Email Sent!", {
                        closeButton: false,
                    });
                    // this.toggleSendEmailSubscribers();
                    this.setState({
                        sendEmail: false,
                        emailAddresses: [],
                    });
                },
                (error) => {
                    toast.error("There was an error", {
                        closeButton: false,
                    });
                    // this.toggleSendEmailSubscribers();
                    this.setState({ sendEmail: false });
                }
            );
    };
    toggleModifyResident = (active) => {
     console.log(active)
        this.setState({
            modalModifyResident: !this.state.modalModifyResident,
        });
    };
    toggleModifyGuest = (active) => {
     console.log("Guest")
        this.setState({
            modalModifyGuest: !this.state.modalModifyGuest,
        });
    };
    toggleAddResident = () => {
        this.setState({
            modalAddNewSubscriber: !this.state.modalAddNewSubscriber,
        });
    };
    toggleAddResidentResubmit = () => {
        this.setState({
            modalAddNewSubscriberResubmit:
                !this.state.modalAddNewSubscriberResubmit,
        });
    };
    toggleAddGuestResubmit = () => {
        this.setState({
            modalAddNewGuestResubmit: !this.state.modalAddNewGuestResubmit,
        });
    };
    toggleEndedSubscriptionInfo = () => {
        this.setState({
            modalEndedSubscriptionInfo: !this.state.modalEndedSubscriptionInfo,
        });
    };
    resubmitModify = (
        email,
        firstName,
        lastName,
        phoneNumber,
        selectedLanguage,
        venueID,
        optionTemplateUnits,
        optionTemplateBuilding,
        unitName,
        buildingName,
        floorName,
        selectedServicePlanID,
        unitID_internal,
        purpose
    ) => {
        this.handleSelectChangeVenue(venueID, unitName);
        // console.log("ResubmitModify: ", unitName)
        this.setState({
            email: email,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            selectedLanguage: selectedLanguage,
            // venueID: venueID,
            optionTemplateUnits: optionTemplateUnits,
            optionTemplateBuilding: optionTemplateBuilding,
            selectedUnit: unitName,
            selectedBuilding: buildingName,
            selectedFloor: floorName,
            selectedServicePlanID: selectedServicePlanID,
            unitID_internal: unitID_internal,
        });
        this.toggleEndedSubscriptionInfo();
        if (purpose === "localwirelessonly") {
            this.toggleAddGuestResubmit();
        } else {
            this.toggleAddResidentResubmit();
        }
    };
    changeHandlerRadio = (nr) => () => {
        this.handleSelectChangeVenue();
        // console.log(nr);
        this.setState({
            setSearchBy: nr,
            subscriberPhone: undefined,
            subscriberEmail: undefined,
            searchResults: undefined,
        });
    };
    render() {
        // console.log("Active: ", this.state.active);
        // console.log(this.state.paymentFailed && (this.state.active === "false" || this.state.active === undefined));
        // console.log("ModalAddPayment: ", this.state.modalAddPayment);
        let url = [
            "roamingiq.wifikey.link",
            "roamingiq.roamingiqtest.com",
            "demo.roamingiq.com",
            "localhost",
        ];
        if (url.includes(window.location.hostname)) {
            showSendEmail = true;
        }
        if (this.state.postMessage) {
            var h = document.getElementById("overlaySubscriberManagement");
            h.style.display = "block";
            setTimeout(function () {
                h.style.display = "block";
            }, 5000);
            setTimeout(() => {
                h.style.display = "none";
                this.setState({ postMessage: "" });
            }, 6000);
        }
        const { editorHeaderState, editorMessageState } = this.state;
        return (
            <>
                {this.state.paymentFailed &&
                (this.state.active === "false" ||
                    this.state.active === undefined) ? (
                    <MDBModal
                        isOpen={this.state.paymentFailed}
                        toggle={this.togglePayment}
                        size="md"
                        className="form"
                        centered
                        style={{ zIndex: 2050 }}
                    >
                        <MDBModalHeader toggle={this.togglePayment}>
                            Modify Billing Credit Card Info
                        </MDBModalHeader>
                        <MDBModalBody className="error">
                            <h4>
                                The subscriber's credit card info needs to be
                                updated for billing purposes.
                            </h4>
                            <MDBBtn
                                color="danger"
                                className="btn Ripple-parent btn-default centered upgradePlan"
                                href={
                                    "/update/checkout?ui=" +
                                    window.location.pathname.slice(1)
                                }
                            >
                                Modify Billing CC
                            </MDBBtn>
                        </MDBModalBody>
                    </MDBModal>
                ) : (
                    ""
                )}
                {this.state.lastProcessed > 0 ? (
                    <>
                        <MDBModal
                            isOpen={this.state.modalError}
                            toggle={this.toggleError}
                            size="md"
                            className="form"
                            centered
                        >
                            <MDBModalHeader toggle={this.toggleError}>
                                <h4>Error Uploading Subscribers</h4>
                            </MDBModalHeader>
                            <MDBModalBody>
                                {this.state.lastProcessed === 1 ? (
                                    <p>
                                        Line {this.state.lastProcessed} (Unit:{" "}
                                        {this.state.unitUnprocessed}, Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed. Re-upload the CSV after
                                        fixing line 1.
                                    </p>
                                ) : (
                                    <p>
                                        Line {this.state.lastProcessed} (Unit:{" "}
                                        {this.state.unitUnprocessed}, Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed. Re-upload the CSV after
                                        fixing line {this.state.lastProcessed}{" "}
                                        and removing lines 1-
                                        {this.state.lastProcessed - 1}.
                                    </p>
                                )}
                            </MDBModalBody>
                        </MDBModal>
                    </>
                ) : (
                    ""
                )}
                {this.state.loading_upload === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayProgressBar">
                            <MDBProgress
                                material
                                value={this.state.progress}
                                height="20px"
                                color="danger"
                                striped
                            />
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {this.props.loading === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggle}>
                    <h4>Subscriber Management</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <div className="managementModal">
                        <MDBRow>
                            <MDBCol size="12" md="6" lg="4">
                                <div
                                    className="managementModalButton"
                                    onClick={this.toggleAddNewSubscriber}
                                >
                                    <MDBIcon icon="user-plus" />
                                    <p>Add New Subscriber</p>
                                </div>
                            </MDBCol>
                            <MDBCol size="12" md="6" lg="4">
                                <div
                                    className="managementModalButton"
                                    onClick={this.toggleViewModifySubscriber}
                                >
                                    <MDBIcon icon="edit" />
                                    <p>View/Modify Subscriber</p>
                                </div>
                            </MDBCol>
                            {sessionStorage.getItem("customerSupport") > 0 ? (
                                ""
                            ) : (
                                <>
                                    <MDBCol size="12" md="6" lg="4">
                                        <div
                                            className="managementModalButton"
                                            onClick={
                                                this
                                                    .toggleBulkDownloadSubscribers
                                            }
                                        >
                                            <MDBIcon icon="cloud-download-alt" />
                                            <p>Export Subscribers</p>
                                        </div>
                                    </MDBCol>
                                    <MDBCol size="12" md="6" lg="4">
                                        <div
                                            className="managementModalButton"
                                            onClick={
                                                this.toggleBulkUploadSubscribers
                                            }
                                        >
                                            <MDBIcon icon="cloud-upload-alt" />
                                            <p>Upload Subscribers</p>
                                        </div>
                                    </MDBCol>
                                </>
                            )}
                            <MDBCol size="12" md="6" lg="4">
                                <div
                                    className="managementModalButton"
                                    onClick={this.toggleSearchSubscriber}
                                >
                                    <MDBIcon icon="search" />
                                    <p>Subscriber Search</p>
                                </div>
                            </MDBCol>
                            {/* <MDBCol md="4">
                <div className="managementModalButton" onClick={this.toggleAbandonedSubscribersTable}>
                  <MDBIcon icon="shopping-cart" />
                  <p>Abandoned signups</p>
                </div>
              </MDBCol>
              <MDBCol md="4">
                <div className="managementModalButton" onClick={this.toggleInvoicesTable}>
                  <MDBIcon icon="file-invoice-dollar" />
                  <p>Invoices</p>
                </div>
              </MDBCol>
              <MDBCol md="4">
                <div className="managementModalButton" onClick={this.togglePaymentUpdateRequiredTable}>
                  <MDBIcon icon="credit-card" />
                  <p>Payment update required</p>
                </div>
              </MDBCol> */}
                            {showSendEmail ? (
                                <MDBCol size="12" md="6" lg="4">
                                    <div
                                        className="managementModalButton"
                                        onClick={
                                            this.toggleSendEmailSubscribers
                                        }
                                    >
                                        <MDBIcon icon="envelope-open" />
                                        <p>Send E-Mail</p>
                                    </div>
                                </MDBCol>
                            ) : (
                                ""
                            )}
                            <MDBCol size="12" md="6" lg="4">
                                    <div
                                        className="managementModalButton"
                                        onClick={
                                            this.toggleAddNewGuest
                                        }
                                    >
                                        <MDBIcon icon="calendar-plus" />
                                        <p>Add New <br/>Guest</p>
                                    </div>
                                </MDBCol>
                        </MDBRow>
                    </div>
                </MDBModalBody>
                <MDBModal
                    isOpen={this.state.modalAddNewSubscriber}
                    toggle={this.toggleAddNewSubscriber}
                    size="lg"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <AddSubscriber
                        toggleAddNewSubscriber={this.toggleAddNewSubscriber}
                        submitHandler={this.submitHandler}
                        loading={this.state.loading}
                        attributeForm={this.state.attributeForm}
                        venueID={this.state.venueID}
                        venueName={this.state.venueName}
                        unitForm={this.state.unitForm}
                        selectedUnit={this.state.selectedUnit}
                        buildingForm={this.state.buildingForm}
                        selectedBuilding={this.state.selectedBuilding}
                        floorForm={this.state.floorForm}
                        selectedFloor={this.state.selectedFloor}
                        hasUpdated={this.state.hasUpdated}
                        hasUpdatedUnit={this.state.hasUpdatedUnit}
                        hasUpdatedBuilding={this.state.hasUpdatedBuilding}
                        hasUpdatedFloor={this.state.hasUpdatedFloor}
                        unitID_internal={this.state.unitID_internal}
                        optionTemplateUnits={this.state.optionTemplateUnits}
                        optionTemplateBuilding={
                            this.state.optionTemplateBuilding
                        }
                        optionTemplateFloor={this.state.optionTemplateFloor}
                        optionTemplateServicePlans={
                            this.state.optionTemplateServicePlans
                        }
                        handleSelectChangeUnit={this.handleSelectChangeUnit}
                        handleSelectChangeBuilding={
                            this.handleSelectChangeBuilding
                        }
                        handleSelectChangeFloor={this.handleSelectChangeFloor}
                        getVenues={this.getVenues}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        clearDropDown={this.state.clearDropDown}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAddNewGuest}
                    toggle={this.toggleAddNewGuest}
                    size="lg"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <AddGuest
                        toggleAddNewGuest={this.toggleAddNewGuest}
                        submitHandlerGuest={this.submitHandlerGuest}
                        loading={this.state.loading}
                        attributeForm={this.state.attributeForm}
                        venueID={this.state.venueID}
                        venueName={this.state.venueName}
                        unitForm={this.state.unitForm}
                        selectedUnit={this.state.selectedUnit}
                        buildingForm={this.state.buildingForm}
                        selectedBuilding={this.state.selectedBuilding}
                        floorForm={this.state.floorForm}
                        selectedFloor={this.state.selectedFloor}
                        hasUpdated={this.state.hasUpdated}
                        hasUpdatedUnit={this.state.hasUpdatedUnit}
                        hasUpdatedBuilding={this.state.hasUpdatedBuilding}
                        hasUpdatedFloor={this.state.hasUpdatedFloor}
                        unitID_internal={this.state.unitID_internal}
                        optionTemplateGuestUnits={this.state.optionTemplateGuestUnits}
                        optionTemplateBuilding={
                            this.state.optionTemplateBuilding
                        }
                        optionTemplateFloor={this.state.optionTemplateFloor}
                        optionTemplateServicePlans={
                            this.state.optionTemplateServicePlans
                        }
                        handleSelectChangeUnit={this.handleSelectChangeUnit}
                        handleSelectChangeBuilding={
                            this.handleSelectChangeBuilding
                        }
                        handleSelectChangeFloor={this.handleSelectChangeFloor}
                        getVenues={this.getVenues}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        clearDropDown={this.state.clearDropDown}
                        duration={this.state.duration}
                        timezone={this.state.timezone}
                        dateStartNow={this.state.dateStartNow}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalViewModifySubscriber}
                    toggle={this.toggleViewModifySubscriber}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <ViewModifySubscribers
                        toggleViewModifySubscriber={
                            this.toggleViewModifySubscriber
                        }
                        attributeForm={this.state.attributeForm}
                        venueID={this.state.venueID}
                        venueName={this.state.venueName}
                        firstID={this.state.firstID}
                        showUpdate={this.props.showUpdate}
                        cancelInputType={this.props.cancelInputType}
                        getVenues={this.getVenues}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        optionTemplateUnits={this.state.optionTemplateUnits}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        handleSelectChangeUnit={this.handleSelectChangeUnit}
                        handleSelectChangeBuilding={
                            this.handleSelectChangeBuilding
                        }
                        getVenueDetails={this.getVenueDetails}
                        submitHandler={this.submitHandler}
                        clearDropDown={this.state.clearDropDown}
                        updateName={this.props.updateName}
                        availablePlans={this.state.availablePlans}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalResendActivation}
                    toggle={this.toggleResendActivation}
                    size="lg"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <ResendActivation
                        toggleResendActivation={this.toggleResendActivation}
                        recentSubscribers={this.props.activeData}
                        submitHandlerResendActivation={
                            this.submitHandlerResendActivation
                        }
                        loading={this.state.loading}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalServicesEndingSoon}
                    toggle={this.toggleServicesEndingSoon}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <ServicesEndingSoon
                        toggleServicesEndingSoon={this.toggleServicesEndingSoon}
                        expirations={this.props.expirations}
                        venueID={this.props.venueID}
                        venueName={this.props.venueNameSelected}
                        updateName={this.props.updateName}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalDownloadSubscribers}
                    toggle={this.toggleBulkDownloadSubscribers}
                    size="md"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <DownloadSubscribers
                        toggleDownloadSubscribers={
                            this.toggleBulkDownloadSubscribers
                        }
                        attributeForm={this.state.attributeForm}
                        venueID={this.state.venueID}
                        venueName={this.state.venueName}
                        loadingVenueDetails={this.state.loadingVenueDetails}
                        hasUpdated={this.state.hasUpdated}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        clearDropDown={this.state.clearDropDown}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalBulkUploadSubscribers}
                    toggle={this.toggleBulkUploadSubscribers}
                    size="lg"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <UploadSubscribers
                        toggleBulkUploadSubscribers={
                            this.toggleBulkUploadSubscribers
                        }
                        attributeForm={this.state.attributeForm}
                        venueID={this.state.venueID}
                        venueName={this.state.venueName}
                        updateName={this.props.updateName}
                        loadingVenueDetails={this.state.loadingVenueDetails}
                        hasUpdated={this.state.hasUpdated}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        getVenues={this.getVenues}
                        clearDropDown={this.state.clearDropDown}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalAbandonedSubscribersTable}
                    toggle={this.toggleAbandonedSubscribersTable}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <AbandonedSubscribers
                        toggleAbandonedSubscribersTable={
                            this.toggleAbandonedSubscribersTable
                        }
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalInvoicesTable}
                    toggle={this.toggleInvoicesTable}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <InvoicesTable
                        toggleInvoicesTable={this.toggleInvoicesTable}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalPaymentUpdateRequiredTable}
                    toggle={this.togglePaymentUpdateRequiredTable}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <PaymentUpdateRequiredTable
                        togglePaymentUpdateRequiredTable={
                            this.togglePaymentUpdateRequiredTable
                        }
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalSearchSubscriber}
                    toggle={this.toggleSearchSubscriber}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <SearchSubscribers
                        toggleSearchSubscriber={this.toggleSearchSubscriber}
                        loading={this.state.loading}
                        showUpdate={this.props.showUpdate}
                        cancelInputType={this.props.cancelInputType}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        optionTemplateUnits={this.state.optionTemplateUnits}
                        optionTemplateGuestUnits={this.state.optionTemplateGuestUnits}
                        optionTemplateUnitsSearch={this.state.optionTemplateUnitsSearch}
                        optionTemplateBuilding={
                            this.state.optionTemplateBuilding
                        }
                        optionTemplateFloor={this.state.optionTemplateFloor}
                        hasUpdated={this.props.hasUpdated}
                        venueInfo={this.state.venueInfo}
                        handleSelectChangeVenue={this.handleSelectChangeVenue}
                        handleSelectChangeUnit={this.handleSelectChangeUnit}
                        handleSelectChangeUnitInitial={
                            this.handleSelectChangeUnitInitial
                        }
                        handleSelectChangeBuilding={
                            this.handleSelectChangeBuilding
                        }
                        handleSelectChangeFloor={this.handleSelectChangeFloor}
                        venueID={this.state.venueID}
                        clearDropDown={this.state.clearDropDown}
                        getVenues={this.getVenues}
                        unitID_internal={this.state.unitID_internal}
                        getVenueDetails={this.getVenueDetails}
                        submitHandler={this.submitHandler}
                        submitHandlerGuest={this.submitHandlerGuest}
                        optionTemplateServicePlans={
                            this.state.optionTemplateServicePlans
                        }
                        getVenueUnitDetails={this.getVenueUnitDetails}
                        findSubscribers={this.findSubscribers}
                        searchResults={this.state.searchResults}
                        modalEndedSubscriptionInfo={
                            this.state.modalEndedSubscriptionInfo
                        }
                        modalAddNewSubscriberResubmit={
                            this.state.modalAddNewSubscriberResubmit
                        }
                        modalModifyResident={this.state.modalModifyResident}
                        modalModifyGuest={this.state.modalModifyGuest}
                        loadingVenueDetails={this.state.loadingVenueDetails}
                        venueUnitData={this.state.venueUnitData}
                        unitData={this.state.unitData}
                        venueName={this.state.venueName}
                        SubscriberGivenName={this.state.SubscriberGivenName}
                        SubscriberFamilyName={this.state.SubscriberFamilyName}
                        SubscriberEmail={this.state.SubscriberEmail}
                        SubscriberPhoneNumber={this.state.SubscriberPhoneNumber}
                        receivetext={this.state.contactpref_email}
                        receivephone={this.state.contactpref_sms}
                        contactpref_sms={this.state.contactpref_sms}
                        contactpref_email={this.state.contactpref_email}
                        SubscriberLocale={this.state.SubscriberLocale}
                        UnitFloor={this.state.UnitFloor}
                        UnitBuilding={this.state.UnitBuilding}
                        StartDateTime={this.state.StartDateTime}
                        EndDateTime={this.state.EndDateTime}
                        UnitID={this.state.UnitID}
                        submitModify={this.submitModify}
                        submitDelete={this.deleteResident}
                        SSID={this.state.SSID}
                        servicePlanID={this.state.servicePlanID}
                        servicePlan={this.state.servicePlan}
                        availablePlans={this.state.availablePlans}
                        // getVenueDetails={this.getVenueDetails}
                        vlan={this.state.vlan}
                        status={this.state.status}
                        PMS={this.state.PMS}
                        PMSSyncDate={this.state.PMSSyncDate}
                        subscriberManagedviaSSO={
                            this.state.subscriberManagedviaSSO
                        }
                        paymentFailed={this.state.paymentFailed}
                        StripeClientSecret={this.state.StripeClientSecret}
                        country={this.state.country}
                        subscriptionDiscount={this.state.subscriptionDiscount}
                        venueDiscount={this.state.venueDiscount}
                        externalSubscriberID={this.state.externalSubscriberID}
                        selectedServicePlanPrice={
                            this.state.selectedServicePlanPrice
                        }
                        stripeClientParentSecret={
                            this.state.stripeClientParentSecret
                        }
                        setupIntentID={this.state.setupIntentID}
                        toggleEndedSubscriptionInfo={
                            this.toggleEndedSubscriptionInfo
                        }
                        toggleAddResidentResubmit={
                            this.toggleAddResidentResubmit
                        }
                        toggleAddGuestResubmit={this.toggleAddGuestResubmit}
                        modalAddNewGuestResubmit={
                            this.state.modalAddNewGuestResubmit
                        }
                        unitForm={this.state.unitForm}
                        selectedUnit={this.state.selectedUnit}
                        buildingForm={this.state.buildingForm}
                        selectedBuilding={this.state.selectedBuilding}
                        floorForm={this.state.floorForm}
                        selectedFloor={this.state.selectedFloor}
                        resubmitModify={this.resubmitModify}
                        selectedServicePlanID={this.state.selectedServicePlanID}
                        changeHandler={this.changeHandler}
                        changeHandlerPhone={this.changeHandlerPhone}
                        changeHandlerRadio={this.changeHandlerRadio}
                        subscriberEmail={this.state.subscriberEmail}
                        subscriberPhone={this.state.subscriberPhone}
                        toggleModifyResident={this.toggleModifyResident}
                        toggleModifyGuest={this.toggleModifyGuest}
                        setSearchBy={this.state.setSearchBy}
                        loadingRecreateSubscription={
                            this.state.loadingRecreateSubscription
                        }
                        togglePayment={this.togglePayment}
                        modalAddPayment={this.state.modalAddPayment}
                        loadingSearchResults={this.state.loadingSearchResults}
                        active={this.state.active}
                        updateName={this.props.updateName}
                        isVenuePMSConfigured={this.state.isVenuePMSConfigured}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalSendEmailSubscribers}
                    toggle={this.toggleSendEmailSubscribers}
                    size="fluid"
                    className="form"
                    centered
                    keyboard={false}
                >
                    <MDBModalHeader toggle={this.toggleSendEmailSubscribers}>
                        <h4>Send Email to Subscribers</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <form
                            className="needs-validation"
                            onSubmit={this.submitSendEmail}
                            noValidate
                        >
                            <label
                                htmlFor="defaultFormLoginEmailEx"
                                className="black-text"
                            >
                                Email Addresses (separate each by comma)
                            </label>
                            <br />
                            {this.state.emailAddresses.map((item) => (
                                <div className="tag-item" key={item}>
                                    {item}
                                    <button
                                        type="button"
                                        className="button"
                                        onClick={() => this.handleDelete(item)}
                                    >
                                        &times;
                                    </button>
                                </div>
                            ))}
                            <input
                                className={
                                    "form-control input " +
                                    (this.state.error && " has-error")
                                }
                                value={this.state.value}
                                placeholder="Type or paste email addresses and press `Enter`..."
                                onKeyDown={this.handleKeyDown}
                                onChange={this.handleChange}
                                onPaste={this.handlePaste}
                            />
                            {this.state.error && (
                                <p className="error">{this.state.error}</p>
                            )}
                            <br />
                            <label
                                htmlFor="defaultFormLoginEmailEx"
                                className="black-text"
                            >
                                Email Subject
                            </label>
                            <input
                                name="emailSubject"
                                id="emailSubject"
                                className="form-control"
                                onChange={this.changeHandler}
                                value={this.state.emailSubject}
                            />
                            <br />
                            <label
                                htmlFor="defaultFormLoginEmailEx"
                                className="black-text"
                            >
                                Title
                            </label>
                            <input
                                name="emailTitle"
                                id="emailTitle"
                                className="form-control"
                                onChange={this.changeHandler}
                                value={this.state.emailTitle}
                            />
                            <br />
                            <label
                                htmlFor="defaultFormLoginEmailEx"
                                className="black-text"
                            >
                                Header
                            </label>
                            <Editor
                                name="emailHeader"
                                className="form-control"
                                editorState={editorHeaderState}
                                editorClassName="form-control editorHeader"
                                onEditorStateChange={
                                    this.onEditorHeaderStateChange
                                }
                                toolbar={{
                                    options: [
                                        "inline",
                                        "blockType",
                                        "fontSize",
                                        "fontFamily",
                                        "list",
                                        "textAlign",
                                        "link",
                                    ],
                                }}
                            />
                            <br />
                            <label
                                htmlFor="defaultFormLoginEmailEx"
                                className="black-text"
                            >
                                Message
                            </label>
                            <Editor
                                className="form-control"
                                editorState={editorMessageState}
                                editorClassName="form-control editorMessage"
                                onEditorStateChange={
                                    this.onEditorMessageStateChange
                                }
                                toolbar={{
                                    options: [
                                        "inline",
                                        "blockType",
                                        "fontSize",
                                        "fontFamily",
                                        "list",
                                        "textAlign",
                                        "link",
                                    ],
                                }}
                            />
                            <div className="text-right submitButton">
                                <MDBBtn color="danger" type="submit">
                                    {this.state.sendEmail === true ? (
                                        <div
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                    ) : (
                                        "Send Email"
                                    )}
                                </MDBBtn>
                            </div>
                        </form>
                    </MDBModalBody>
                </MDBModal>
            </>
        );
    }
}
export default withTranslation()(SubscriberManagementNavigation);
